(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Masque le widget Zendesk tant que le panier latéral est ouvert (il passait au-dessus du bouton de paiement)
  (() => {
    const setZendeskVisibility = (visible) => {
      if (typeof window.zE !== "function") {
        return;
      }

      const action = visible ? "show" : "hide";

      // Messagerie (nouveau widget Zendesk) puis Web Widget (ancien) : l'API non utilisée est simplement ignorée
      try { window.zE("messenger", action); } catch (error) {}
      try { window.zE("webWidget", action); } catch (error) {}
    };

    // Ces événements ne "remontent" pas dans le DOM : on les écoute donc en phase de capture sur le document
    document.addEventListener("dialog:before-show", (event) => {
      if (event.target.tagName === "CART-DRAWER") {
        setZendeskVisibility(false);
      }
    }, true);

    document.addEventListener("dialog:after-hide", (event) => {
      if (event.target.tagName === "CART-DRAWER") {
        setZendeskVisibility(true);
      }
    }, true);
  })();

  } catch(e) { console.error(e); }
})();
})();
